import axios from 'axios'
import { map } from 'lodash'
import { dateToYYYYMMDDHHmmSS } from './JSUtils'
const url = process.env.VUE_APP_PRINTER_SERVICE_URL
    ? process.env.VUE_APP_PRINTER_SERVICE_URL + '/pos_sale'
    : 'https://localhost:5200/api/pos_sale'

const itemFormatter = items =>
    map(items, item => {
        let price = item.sale_price
        if (item.discounted_price) price = item.discounted_price
        if (item.neto) {
            price = item.neto
        }
        if (item.replaced_price && item.replaced_price.replaced)
            price = item.sale_price
        let obj = {
            product_name: item.name,
            quantity: parseFloat(item.quantity),
            price,
            net_price: price || null,
            discount_percentage: item.lineDiscount
                ? item.lineDiscount.percentage_discount || 0
                : 0,
            discount_line_amount: item.lineDiscount
                ? item.lineDiscount.unit_price_discount || 0
                : 0,
            sub_total: parseInt(item.subtotal),
        }
        if (item.neto) delete obj.price
        else if (obj.price) delete obj.net_price
        return obj
    })

const formatProducts = payload =>
    payload.items
        ? itemFormatter(payload.items)
        : /*
        map(payload.items, item => {
              let price = item.sale_price
              if (item.discounted_price) price = item.discounted_price
              if (item.neto) {
                  price = item.neto
              }
              if (item.replaced_price && item.replaced_price.replaced)
                  price = item.sale_price
              let obj = {
                  product_name: item.name,
                  quantity: item.quantity,
                  price,
                  net_price: price || null,
                  discount_percentage: item.lineDiscount
                      ? item.lineDiscount.percentage_discount || 0
                      : 0,
                  discount_line_amount: item.lineDiscount
                      ? item.lineDiscount.unit_price_discount || 0
                      : 0,
                  sub_total: item.subtotal,
              }
              if (item.neto) delete obj.price
              else if (obj.price) delete obj.net_price
              return obj
          })
          */
          '-'

const calcDiscountAsAmount = (percentage, total) => {
    try {
        return (
            Math.round((100 * total) / (100 - parseInt(percentage))) - total
        ).toLocaleString('es')
    } catch (e) {
        return null
    }
}

const formatBase = payload => ({
    company_name: payload.title,
    header_subtitle: payload.subtitle,
    sale_date_time:
        payload.dateTime && payload.dateTime.date && payload.dateTime.time
            ? payload.dateTime.date + ' ' + payload.dateTime.time
            : dateToYYYYMMDDHHmmSS(new Date()),
    sale_seller: payload.seller,
    sale_type: payload.saleType,
    sale_products: formatProducts(payload),
    discount_text:
        payload.globalDiscount && payload.globalDiscount.percentage_discount
            ? `Descuento global aplicado de ${parseInt(
                  payload.globalDiscount.percentage_discount
              )}%, equivalente a $${calcDiscountAsAmount(
                  payload.globalDiscount.percentage_discount,
                  payload.total
              )}`
            : payload.globalDiscount && payload.globalDiscount.amount_discount
            ? `Descuento global aplicado de $${parseInt(
                  payload.globalDiscount.amount_discount
              )}`
            : '',
    total_entrante: 0, // No sé que es, pero estaba en el front
    total: payload.total,
    footer_text: 'DOCUMENTO NO VÁLIDO COMO BOLETA',
    total_iva: payload.iva || 0,
    total_neto: payload.neto || 0,
})

const addTopBarCode = payload => ({
    sale_code: payload.barcode,
})

const addEmployee = payload => ({
    sale_employee: payload.requester_employee,
})

const addCustomerData = payload => ({
    customer_rut: payload.cRUT,
    customer_business_name: payload.cbusinessName,
    customer_alias_name: payload.cpersonName,
    customer_commercial_business: payload.cactivities,
    customer_address: payload.caddress,
    customer_phone: '',
    customer_email: '', //payload.cmail,
})

const addCompanyData = payload => ({
    header_rut: `RUT: ${payload.RUT}`,
    business_comercial_business: payload.activities,
    business_address: payload.address,
    business_phone: '',
})

const addQuotationData = payload =>
    Object.assign(addCompanyData(payload), addCustomerData(payload), {
        footer_barcode: payload.barcode,
        disclaimer_text: `COTIZACIÓN VALIDA HASTA EL ${payload.quotationExpiration}`,
    })

const addDispatchRequestData = payload =>
    Object.assign(addCompanyData(payload), addCustomerData(payload), {
        header_rut: `RUT: ${payload.RUT}`,
        remark_quantities: true,
        footer_text: null,
        customer_city: payload.cCity || '',
        customer_commune: payload.cCommune || '',
        customer_zone: payload.cZone || '',
    })

const addChangeData = payload => ({
    in_sale_product_message: 'ENTRANTE',
    in_sale_products: itemFormatter(payload.incomingDetail || []),
    detail_product_message: 'SALIENTE',
    total_entrante: payload.incomingTotal,
    total_saliente: payload.total,
    total: payload.total - payload.incomingTotal,
    discount_text: '',
})

const formatPayload = payload => {
    let obj = formatBase(payload)
    if (payload.typeCode === 3) {
        obj = Object.assign(obj, addQuotationData(payload))
    } else if (payload.typeCode === 2) {
        obj = Object.assign(obj, addCustomerData(payload))
    } else if (payload.typeCode === 6) {
        obj = Object.assign(obj, addChangeData(payload))
    } else if (payload.typeCode === 10) {
        obj = Object.assign(obj, addDispatchRequestData(payload))
    }
    if (payload.typeCode !== 3) {
        obj = Object.assign(obj, addTopBarCode(payload))
    }
    if ([4, 5].includes(payload.typeCode)) {
        obj = Object.assign(obj, addEmployee(payload))
    }
    return obj
}

/**
 * 
 */
function timeout() {
    // required
    let psTimeoutDefault = "8000"
    let psTimeoutEnv    = process.env.VUE_APP_PRINTER_SERVICE_TIMEOUT
    let psTimeout       = parseInt(psTimeoutEnv || psTimeoutDefault)
    // timeout promise
    return new Promise((resolve, reject) => {
        setTimeout(() => reject(), psTimeout)
    })
}

export default {
    formatPayload,
    print: payload => {
        return new Promise((resolve, reject) =>
            axios
                .post(url, formatPayload(payload))
                .then(resolve)
                .catch(reject)
        )
    },
    timeout,
}